import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export interface ExpandIconProps extends MuiIconExternalProps {
    isExpanded: boolean;
}

export const ExpandIcon = ({isExpanded, ...props}: ExpandIconProps) => {
    return (
        isExpanded
            ? <MuiIcon {...props}
            >{'\ue5cf'}</MuiIcon>
            : <MuiIcon {...props}
            >{'\ue5cc'}</MuiIcon>
    );
}